import React from 'react'
import { htmlToReactElementWithInnerHtml } from'./htmlToReactElementWithInnerHtml'

const Html = (props) => {
  return (
    <React.Fragment>{ htmlToReactElementWithInnerHtml(props.data.epaper_html_block) }</React.Fragment>
  )
}

export default Html;
